export default "__VITE_ASSET__RPJSoh_2__"